<template>
    <div class="body back-gray">
        <div class="wrap end txt-center">
            <p class="bold font-20">
                응시가 완료되었습니다.
            </p>
            <p class="font-16 mt-20">
                응시완료일 : {{applicationDate}}
            </p>
        </div>
        <div class="wrap">
            <div class="btn-fixed">
                <p class="start-txt">평가는 응시일로부터 2일 내 완료됩니다. (영업일 기준)</p>
                <button class="btn-full" @click="goIntro()">확인</button>
            </div>
        </div>
        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
    import Footer from '@/components/footer.vue';
    export default {
        name: 'IntroEnd',
        components: {
            Footer
        },
        data: () => ({
            applicationDate:""
        }),
        mounted() {
            this.applicationDate = atob(this.$route.params.applicationDate);
        },
        methods: {
            goIntro(){
                location.href='/intro'
            }

        }
    }
</script>